module.exports = __webpack_public_path__ + "img/th-th.67ed4aff.svg";